<template>
  <div id="app">
    <vue-extend-layouts path="layouts" layout="MainLayout"/>
  </div>
</template>

<script>
/* Layout Libraries 설정
*  default 이름 변경 시 prop layout에 변경된 이름을 명시해줘야함
* */
import VueExtendLayouts from 'vue-extend-layout'
export default {
  name: 'App',
  metaInfo: {
    title: "Etners KIOSK Portal",
    link: [
      {
        rel: 'icon',
        href: 'https://ds.eskiosk.com/favicon_16.ico'
      },
      {
        rel: 'icon',
        href: 'https://ds.eskiosk.com/favicon_32.ico'
      },
    ],
    script: [
      {
        type: 'text/javascript',
      //   src: "/resources/rsa/rsa.js"
      // },
      // {
      //   type: 'text/javascript',
      //   src: "/resources/rsa/jsbn.js"
      // },
      // {
      //   type: 'text/javascript',
      //   src: "/resources/rsa/prng4.js"
      // },
      // {
      //   type: 'text/javascript',
      //   src: "/resources/rsa/rng.js"
        src: "/resources/rsa/rsa-bundle.js"
      },
    ],
  },
  components: { VueExtendLayouts }
}
</script>
